// extracted by mini-css-extract-plugin
export var active = "_5m-1";
export var activeSubdued = "_5m-2";
export var compact = "_5m-3";
export var pulse = "_5m-4";
export var settingHighlightPulse = "_5m-5";
export var wrapper = "_5m-0";